import React, {FunctionComponent} from 'react'

import {Classes} from '../../../../styles'
import {StatisticsData, StatisticsInWork} from '../../../../responses/statistics'


interface Props {
    data: StatisticsData<StatisticsInWork>,
}

const StatisticsInWork: FunctionComponent<Props> = ({data}) => {

    return <>
        <div className={Classes.f13b}>Сейчас в работе:</div>

        <div><span>Проекты:</span> <span className={Classes.f13b}>{data.total.projects}</span></div>
        <div><span>Объекты:</span> <span className={Classes.f13b}>{data.total.project_work_objects}</span></div>
        <div><span>Тендеры:</span> <span className={Classes.f13b}>{data.total.tenders}</span></div>
        <div><span>Задачи: </span> <span className={Classes.f13b}>{data.total.tasks}</span></div>
    </>
}

export default StatisticsInWork